<span
  *ngIf="number > 0"
  class="number-indicator"
>
  {{number}}
</span>
